import { array, object, string } from "yup";
import PageBlock from "@page-js/Pages/Page/Editor/scripts/pageBlock";

export default class QuickButton extends PageBlock {
  public getType(): string {
    return "QuickButton";
  }

  protected init(): any {
    return {
      props: {
        items: [],
      },
      attrs: {},
    };
  }

  public validateOrThrow(): Promise<any> {
    const schema = object().shape({
      props: object()
        .shape({
          items: array()
            .of(
              object().shape({
                icon: string().url().required().label("아이콘"),
                title: string().max(64).required().label("제목"),
                description: string().max(256).nullable().label("설명"),
                href: string().required().label("링크"),
                type: string().oneOf(["link", "block"]).required().label("타입"),
                target: string().oneOf(["_self", "_blank"]).required().label("타겟"),
              }),
            )
            .min(1)
            .required()
            .label("버튼 목록"),
        })
        .label("옵션"),
      attrs: object().required().label("속성"),
    });

    return schema.validate(this.toJSON(), { abortEarly: false });
  }
}
